import config from '../config';
class UserService{
    //on successfull set session
    setSession=(userinfo)=>{
        localStorage.removeItem("USER");
        localStorage.setItem("USER",JSON.stringify(userinfo));
    }
    getUserFromSession=()=>{
        if(localStorage.getItem("USER")==null)
            return null;
        else
            return JSON.parse(localStorage.getItem("USER"));
    }
    logoutMe=()=>{
        localStorage.removeItem("USER");
    }
    //auth user
    login=(phonenumber,scholarno,password)=>{
       return  fetch(`${config.apibase}/api/login/loginuserinfo?username=${scholarno}&password=${password}&MobileNumber=${phonenumber}`)
       .then(res=> res.json());
    }


}

export default new UserService();